export default "__VITE_ASSET__bc80ee5e__"